import strings from "global/constants/StringConstants";
import { isPhoneValid } from "helpers/methods";
import { FormFields, LoginFields } from "models/interfaces";

export const loginFormField = () => {
  return {
    email: {
      value: "",
      error: "",
    },
    password: {
      value: "",
      error: "",
    },
  } as LoginFields;
};

export const registerFormField = (googleEmail?: string) => {
  return {
    firstName: {
      value: "",
      error: "",
    },
    lastName: {
      value: "",
      error: "",
    },
    company: {
      value: "",
      error: "",
    },
    email: {
      value: googleEmail ? googleEmail : "",
      error: "",
    },
    contact: {
      value: "",
      error: "",
    },
    password: {
      value: "",
      error: "",
    },
  } as FormFields;
};

export const handleLoginValidation = (credentials: any) => {
  let errors = credentials;
  let isValid = true;
  const emailRegex = strings.regex;
  const email = credentials.email.value;
  const password = credentials.password.value;

  if (!email && !password) {
    errors.email.error = "Email is required";
    errors.password.error = "Password is required";
    isValid = false;
  }
  if (!email) {
    errors.email.error = "Please enter email";
    isValid = false;
  }
  if (email) {
    if (!emailRegex.test(email)) {
      errors.email.error = "Please enter valid email";
      isValid = false;
    }
  }
  if (!password) {
    errors.password.error = "Please enter password";
    isValid = false;
  }
  if (password && password.length < 8) {
    errors.password.error = "Password must be 8 character long";
    isValid = false;
  }
  return { isValid, errors };
};

export const registrationValidation = (
  registerUserValue: any,
  isOAuth?: boolean
) => {
  let errors = registerUserValue;
  let isValid = true;
  const firstName = registerUserValue.firstName.value.trim();
  const lastName = registerUserValue.lastName.value.trim();
  const company = registerUserValue.company.value.trim();
  const email = registerUserValue.email.value.trim();
  const contact = registerUserValue.contact.value;
  const password = registerUserValue.password.value.trim();
  if (!firstName) {
    errors.firstName.error = "Please enter first name";
    isValid = false;
  }
  if (!lastName) {
    errors.lastName.error = "Please enter last name";
    isValid = false;
  }
  if (!email) {
    errors.email.error = "Please enter email";
    isValid = false;
  }
  if (!company) {
    errors.company.error = "Please enter company name";
    isValid = false;
  }
  if (!isPhoneValid(contact)) {
    errors.contact.error = "Please enter a valid contact number";
    isValid = false;
  }
  if (!isOAuth && !password) {
    errors.password.error = "Please enter password";
    isValid = false;
  }
  if (!isOAuth && password && password.length < 8) {
    errors.password.error = "Password must be 8 character long";
    isValid = false;
  }
  if (!isOAuth && !strings.passwordValidationRegex.test(password)) {
    errors.password.error =
      "Please enter a password that is at least 8 characters long and includes at least one digit, one lowercase letter, one uppercase letter, and one special character from the following: @ $ ! % * ? & #.";
    isValid = false;
  }

  if (!strings.regex.test(email)) {
    errors.email.error = "Please enter valid email id";
    isValid = false;
  }

  return { isValid, errors };
};
